export default {
  prepare: (val: any) => ({title: String(val)}),
}
